import React, { useEffect } from 'react';
import { Alert, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { removeAlertMessage } from './dashboardSlice';
import { RootState } from '../../reducers';

const AlertMessage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { dashboard } = useSelector((state: RootState) => state);
  const { alertMessageStack } = dashboard;
  const lastMessage = alertMessageStack[alertMessageStack.length - 1];

  const handleOnClick = () => {
    dispatch(removeAlertMessage());
  };

  // Auto-dismiss success messages after 4 seconds
  useEffect(() => {
    if (lastMessage && lastMessage.type === 'success') {
      console.log(
        'Setting up auto-dismiss timer for success message:',
        lastMessage.message
      );
      const timer = setTimeout(() => {
        console.log('Auto-dismissing success message:', lastMessage.message);
        dispatch(removeAlertMessage());
      }, 4000); // 4 seconds for success messages

      return () => {
        console.log('Clearing auto-dismiss timer for:', lastMessage.message);
        clearTimeout(timer);
      };
    }

    // Always return a cleanup function to satisfy ESLint consistent-return
    return () => {};
  }, [lastMessage, dispatch]);

  // Auto-dismiss alert messages when navigating to a different page
  useEffect(() => {
    if (lastMessage) {
      console.log(
        'Navigation detected, dismissing alert:',
        lastMessage.message
      );
      dispatch(removeAlertMessage());
    }
  }, [location.pathname, dispatch]);

  if (!lastMessage) return null;
  const { message, type, buttonText, link } = lastMessage;
  return (
    <Alert
      severity={type}
      sx={{
        borderRadius: 0, // Remove border radius
        '& .MuiSvgIcon-root': {
          fontSize: 'unset', // This unsets the SVG icon font size
        },
      }}
      action={
        <Button
          color="secondary"
          variant="outlined"
          onClick={handleOnClick}
          href={link}
        >
          {buttonText}
        </Button>
      }
    >
      {message}
    </Alert>
  );
};

export default AlertMessage;
